export var DirectionContent;
(function (DirectionContent) {
    DirectionContent["N"] = "N";
    DirectionContent["NNE"] = "NNE";
    DirectionContent["NE"] = "NE";
    DirectionContent["ENE"] = "ENE";
    DirectionContent["E"] = "E";
    DirectionContent["ESE"] = "ESE";
    DirectionContent["SE"] = "SE";
    DirectionContent["SSE"] = "SSE";
    DirectionContent["S"] = "S";
    DirectionContent["SSW"] = "SSW";
    DirectionContent["SW"] = "SW";
    DirectionContent["WSW"] = "WSW";
    DirectionContent["W"] = "W";
    DirectionContent["WNW"] = "WNW";
    DirectionContent["NW"] = "NW";
    DirectionContent["NWN"] = "NWN";
    DirectionContent["NNW"] = "NNW";
})(DirectionContent || (DirectionContent = {}));
export const directionContentOptions = [
    { value: DirectionContent.N, text: DirectionContent.N },
    { value: DirectionContent.NNE, text: DirectionContent.NNE },
    { value: DirectionContent.NE, text: DirectionContent.NE },
    { value: DirectionContent.ENE, text: DirectionContent.ENE },
    { value: DirectionContent.E, text: DirectionContent.E },
    { value: DirectionContent.ESE, text: DirectionContent.ESE },
    { value: DirectionContent.SE, text: DirectionContent.SE },
    { value: DirectionContent.SSE, text: DirectionContent.SSE },
    { value: DirectionContent.S, text: DirectionContent.S },
    { value: DirectionContent.SSW, text: DirectionContent.SSW },
    { value: DirectionContent.SW, text: DirectionContent.SW },
    { value: DirectionContent.WSW, text: DirectionContent.WSW },
    { value: DirectionContent.W, text: DirectionContent.W },
    { value: DirectionContent.WNW, text: DirectionContent.WNW },
    { value: DirectionContent.NW, text: DirectionContent.NW },
    { value: DirectionContent.NNW, text: DirectionContent.NNW },
];
//# sourceMappingURL=DirectionContent.js.map